"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatName;
function formatName(context, name) {
  var sectionPrefix = context._reduxForm.sectionPrefix;

  return !sectionPrefix ? name : sectionPrefix + "." + name;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/util/prefixName.js
// module id = 77
// module chunks = 0